(function () {
  "use strict";

  var allowedCtaIds = [
    "calculator-tip",
    "retatrutide-guide",
    "ghk-cu-guide",
    "bpc-157-guide",
    "tb-500-guide",
    "glow-stack-guide",
    "article-partner",
  ];
  var allowedPlacements = ["calculator-tip", "calculator-guide", "article-inline"];
  var allowedDestinations = [
    "peptide_calculator",
    "ahk_cu",
    "bac_water_10ml",
    "bpc_157",
    "cagrilintide",
    "cjc_1295",
    "cjc_ipamorelin_blend",
    "epithalon",
    "ghk_cu",
    "glow_stack",
    "ipamorelin",
    "klow_stack",
    "kpv",
    "melanotan_1",
    "mots_c",
    "melanotan_2",
    "nad_plus",
    "pt_141",
    "retatrutide",
    "selank",
    "semax",
    "ss_31",
    "tb_500",
    "tb_500_bpc_157_blend",
    "tesamorelin",
    "thymosin_alpha_1",
    "tirzepatide",
    "vip",
    "5_amino_1mq",
    "dsip",
    "kisspeptin_10",
    "pinealon",
    "sermorelin",
    "survodutide",
  ];

  function isAllowed(values, value) {
    return values.indexOf(value) !== -1;
  }

  function hasAnalyticsConsent() {
    return window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.analyticsProcessingAllowed && window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true;
  }

  document.addEventListener("click", function (event) {
    var cta = event.target.closest("[data-ph-bergdorf-cta]");
    if (!cta || !hasAnalyticsConsent()) return;

    var ctaId = cta.dataset.phBergdorfCta;
    var placement = cta.dataset.phPlacement;
    var destination = cta.dataset.phDestination;
    if (!isAllowed(allowedCtaIds, ctaId) || !isAllowed(allowedPlacements, placement) || !isAllowed(allowedDestinations, destination)) return;

    var EventConstructor = window.CustomEvent || CustomEvent;
    document.dispatchEvent(new EventConstructor("parahealth:bergdorf-cta-click", {
      detail: { ctaId: ctaId, placement: placement, destination: destination },
    }));
  });
})();
